<template>
    <b-modal
        v-model="openModal"
        :title="`Permisos de la compañia: ${company.nombre}`"
        header-bg-variant="dark"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        size="lg">
        <p class="mb-0" style="font-size: 21px"><b>Permisos de la compañia</b></p>
        
        <b-row v-for="(item, index) in permissionList" :key="index">
            <b-col cols="12" md="12">
                <p class="mb-0" style="font-size: 21px">{{index}}</p>
            </b-col>
            <b-col cols="6" md="12" v-for="(item, key) in item" :key="key">
                <b-form-checkbox
                    v-model="permissions[key]"
                    name="checkbox-1"
                    :value=key.checked
                    >
                    {{item}}
                </b-form-checkbox>
                
            </b-col>
        </b-row>
    
        <template v-slot:modal-footer>
            <b-button variant="danger"
                @click.prevent="$emit('close-modal')">
                Cancelar
            </b-button>
            <b-button variant="success"
                @click.prevent="updatePermissionsCompany" >
                Actualizar Permisos
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'companyPermissions',
    props: {
        openModal: {
            type: Boolean
        },
        company: {
            type: Object
        }
    },
    data(){
        return{
            permissionList: {},
            permissions: [],
            message: '',
        }
    },
    created(){
        this.getAvailablePermissionsCompany();
        this.getCompanyPermissions();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getAvailablePermissionsCompany(){
            this.setLoading(true)
            await this.$conectar.post('/admin/empresas/get-available-permissions-list-empresa')
            .then(response=>{
                this.permissionList = response.data.permissions;
            })
            .catch(response =>{
                console.log(response);
            })
            this.setLoading(false)
        },
        async getCompanyPermissions(){
            this.setLoading(true)
            await this.$conectar.post('/admin/empresas/get-current-permissions-empresa', {empresa_id: this.company.id })
            .then(response =>{
                let data = response.data.empresaData;
                data.permissions.forEach(key => {
                    // $set used here was to set reactive properties to the object
                    this.$set(this.permissions, key, true); 
                });
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async updatePermissionsCompany(){
            this.setLoading(true)
            let permissionArray = Object.keys(this.permissions).filter(key => this.permissions[key]);
            let data = {
                empresa_id: this.company.id, 
                permissions: permissionArray
            };
            this.$emit('close-modal')
            await this.$conectar.post('/admin/empresas/update-permissions-empresa', data)
            .then(response => {
                let variant = response.data.error ? "danger" : "success";
                this.$root.$bvToast.toast(response.data.message, {
                    title: "Respuesta del servidor",
                    variant: variant,
                    solid: true
                })
            })
            .catch(response =>{
                console.log(response);
                this.$root.$bvToast.toast("Error en el servidor, favor intente nuevamente", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        }
    }
}

</script>
